import { Flex } from 'antd';
import styled from 'styled-components';

export const HeaderWrapper = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
  flex: 1,
})``;

export const Wrapper = styled(Flex).attrs({
  vertical: true,
})<{ $isDesktop: boolean }>`
  ${({ $isDesktop }) =>
    !$isDesktop &&
    `
   margin-bottom: 111px;
   gap: 16px;
  `}
`;
